export default __webpack_public_path__ + "6989c6466416131559b8aaedcebb85f3.png";